import { useEffect, useId, useRef, useState, type ReactNode } from "react";

/** Dropdown do header (Ações assíncronas, Notificações) sem o JS do Bootstrap. */
export function HeaderDropdown({
  label,
  icon,
  badge,
  text,
  children,
}: {
  label: string;
  icon: ReactNode;
  badge?: number;
  /** Texto visível ao lado do ícone só a partir de lg (no celular fica só o ícone). */
  text?: ReactNode;
  children: ReactNode;
}) {
  const [open, setOpen] = useState(false);
  const id = useId();
  const root = useRef<HTMLDivElement>(null);
  const button = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    if (!open) return;
    const onDown = (e: MouseEvent) => {
      if (!root.current?.contains(e.target as Node)) setOpen(false);
    };
    const onKey = (e: KeyboardEvent) => {
      if (e.key !== "Escape") return;
      // Para aqui: o Esc não chega aos atalhos da página (ex.: Cancelar do FormPage).
      e.stopPropagation();
      setOpen(false);
      button.current?.focus();
    };
    document.addEventListener("mousedown", onDown);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onDown);
      document.removeEventListener("keydown", onKey);
    };
  }, [open]);
  return (
    <div ref={root} className="dropdown">
      <button
        ref={button}
        type="button"
        className="btn btn-link text-reset text-decoration-none position-relative"
        aria-label={label}
        aria-expanded={open}
        aria-controls={id}
        onClick={() => setOpen(!open)}
      >
        {icon}
        {text && <span className="d-none d-lg-inline ms-1 small">{text}</span>}
        {!!badge && (
          <span
            className="position-absolute top-0 start-100 translate-middle badge rounded-pill text-bg-danger"
            aria-hidden="true"
          >
            {badge}
          </span>
        )}
      </button>
      {/* Clicar num link do painel (ex.: "Ver todas") navega e fecha o dropdown. */}
      <div
        id={id}
        className={`dropdown-menu dropdown-menu-end header-dropdown-menu p-0${open ? " show" : ""}`}
        hidden={!open}
        onClick={(e) => {
          if ((e.target as HTMLElement).closest("a")) setOpen(false);
        }}
      >
        {children}
      </div>
    </div>
  );
}
